import React, { useEffect, useState } from "react";
import Select from "pages/forms/_components/_fields/Select";
import flowRight from "lodash/flowRight";
import withFocus from "pages/_components/withFocus";
import formField from "pages/forms/_components/_fields/_commons/formField";
import FormattedAmount from "pages/_components/FormattedAmount";
import ProductTag from "pages/_components/ProductTag";
import { bool, func, shape, string, arrayOf } from "prop-types";

const ProductSelectorCustom = (props) => {
    const {
        idField,
        toggleIsFocused,
        value,
        mode,
        field,
        setValue,
        initialChange = true,
        customPlaceholder = null,
        onChange,
        isRequired,
        data,
        accountSelected,
    } = props;

    // eslint-disable-next-line react/destructuring-assignment
    const { options } = props.data;
    const [initChange, setInitChange] = useState(initialChange);

    const onChangeParent = (id) => {
        if (onChange && mode === "edit" && initChange) {
            onChange(id);
        } else if (!initChange) {
            setInitChange(true);
        }
    };

    const handleChange = ({ id }) => {
        if (id) {
            setValue(id);
        }
    };

    useEffect(() => {
        if (value) {
            setValue(value);
            onChangeParent(value);
        }
        // eslint-disable-next-line
    }, [value]);

    const dataLength = data?.options?.length;

    useEffect(() => {
        let v = value;

        if (mode === "edit") {
            if (!v && !isRequired) {
                v = "";
            }
            if (!v && dataLength) {
                if (accountSelected) {
                    handleChange({ id: accountSelected });
                }
            } else if (v) {
                // es value.value si es un campo cargado con setFieldValue (dado que el valor es
                // {value: xxx, isFrequestDestination: bool}) si es un valor que viene cargado por url,
                // el value es directamente el id de la cuenta es así hasta que eliminemos el
                // isFrequestDestination y esto se resuelva de otra forma (con value solito :P)
                handleChange({ id: v.value || v });
            }
        }
        // eslint-disable-next-line
    }, []);

    const buildProductOptions = () => {
        // \u00A0 es un character especial para forzar un espacio en blanco
        const optionsRes = isRequired
            ? options
            : [{ id: "_empty", isFrequentDestination: false, label: "\u00A0" }, ...options];
        return optionsRes.map((elem) => {
            if (elem.balance) {
                return {
                    id: elem.id,
                    label: (
                        <>
                            <span className="control-label">{elem.label}</span>
                            <FormattedAmount quantity={elem.balance.quantity} currency={elem.balance.currency} />
                        </>
                    ),
                };
            }
            return {
                id: elem.id,
                label: elem.label,
            };
        });
    };

    const renderEditMode = () => (
        <>
            <div className="input-group ">
                <div style={{ flex: 1 }}>
                    {customPlaceholder ? (
                        <Select
                            id={idField}
                            value={value}
                            clearable={false}
                            searchable={false}
                            onChange={handleChange}
                            valueKey="id"
                            labelKey="label"
                            options={buildProductOptions()}
                            onFocus={toggleIsFocused}
                            onBlur={toggleIsFocused}
                            className="flex-container slideFromBottom"
                            optionClassName="needsclick"
                            placeholder={customPlaceholder}
                        />
                    ) : (
                        <Select
                            id={idField}
                            value={value}
                            clearable={false}
                            searchable={false}
                            onChange={handleChange}
                            valueKey="id"
                            labelKey="label"
                            options={buildProductOptions()}
                            onFocus={toggleIsFocused}
                            onBlur={toggleIsFocused}
                            className="flex-container slideFromBottom"
                            optionClassName="needsclick"
                        />
                    )}
                </div>
            </div>
        </>
    );

    const renderPreviewMode = () => {
        const { labelBackoffice } = props;
        const productId = value || accountSelected;
        const { label } = options.find(({ id }) => id === productId) || {};

        return (
            <>
                <ProductTag alias={label || labelBackoffice || field.value} />
            </>
        );
    };

    const renderContent = () => {
        if (mode === "edit") {
            return renderEditMode();
        }

        if (mode === "preview" || mode === "view") {
            return renderPreviewMode();
        }

        return <div />;
    };

    return <>{renderContent()}</>;
};

ProductSelectorCustom.propTypes = {
    value: shape({
        isFrequentDestination: bool,
        value: string,
    }).isRequired,
    toggleIsFocused: func.isRequired,
    mode: string.isRequired,
    isRequired: bool.isRequired,
    onChange: func,
    idField: string.isRequired,
    field: string.isRequired,
    options: arrayOf(shape({})),
    setValue: func,
    accountSelected: shape({}),
    data: shape({}),
    initialChange: bool,
    customPlaceholder: string,
    labelBackoffice: string,
};

ProductSelectorCustom.defaultProps = {
    options: {},
    onChange: () => {},
    setValue: () => {},
    accountSelected: null,
    data: {},
    initialChange: true,
    customPlaceholder: "",
    labelBackoffice: null,
};

export default flowRight(withFocus, formField())(ProductSelectorCustom);
